/**
 * The method name, exposed on the `window` object on the Inside of the iframe,
 * that is called from the Outside and that initializes the loading flow (passing in
 * the scope, drivers, hostConfig, etc).
 */
export const InitializeIframeMethodName = 'initIframe';

/**
 * The component Div ID within the iframe.
 * Used from both inside the iframe AND while constructing the HTML of the page (that way, they match)
 */
export const ComponentDivElementId = 'componentDiv'; /* must match element name in HTML page */
